const workCategories = [
    "Прокладка в траншеях труб чугунных напорных раструбных",
    "Прокладка по стенам зданий и в каналах труб чугунных напорных раструбных",
    "Прокладка в траншеях трубопроводов из чугунных канализационных труб",
    "Прокладка по стенам зданий и в каналах трубопроводов из чугунных канализационных труб",
    "Прокладка трубопроводов отопления из стальных водогазопроводных неоцинкованных труб",
    "Прокладка трубопроводов водоснабжения из стальных водогазопроводных оцинкованных труб",
    "Прокладка трубопроводов газоснабжения из стальных водогазопроводных неоцинкованных труб",
    "Прокладка трубопроводов отопления и газоснабжения из стальных бесшовных труб",
    "Прокладка трубопроводов отопления и водоснабжения из стальных электросварных труб",
    "Прокладка трубопроводов обвязки котлов, водонагревателей и насосов из стальных бесшовных и электросварных труб",
    "Прокладка трубопроводов противопожарного водоснабжения из стальных труб",
    "Прокладка трубопроводов отопления из многослойных металлополимерных труб",
    "Прокладка трубопроводов канализации из полиэтиленовых труб высокой плотности",
    "Прокладка трубопроводов водоснабжения и отопления из хлорированных поливинилхлоридных труб (ХПВХ)",
    "Прокладка внутренних трубопроводов канализации из полипропиленовых труб",
    "Прокладка внутренних трубопроводов водоснабжения и отопления из многослойных полипропиленовых труб, из заранее собранных узлов",
    "Прокладка трубопроводов водоснабжения и отопления из труб из сшитого полиэтилена",
    "Установка фасонных частей чугунных напорных",
    "Сборка узла внутреннего трубопровода водоснабжения и отопления из многослойного полипропилена",
    "Сборка узла трубопровода водоснабжения и отопления из труб сшитого полиэтилена",
    "Изготовление элементов и сборка узлов стальных трубопроводов",
    "Изготовление элементов и сборка узлов стальных трубопроводов из оцинкованных и неоцинкованных водогазопроводных труб",
    "Установка водомерных узлов, поставляемых на место монтажа собранными в блоки, с обводной линией",
    "Установка водомерных узлов, поставляемых на место монтажа собранными в блоки, без обводной линии",
    "Устройство водомерных узлов с изготовлением обвязки на месте монтажа, с обводной линией",
    "Устройство водомерных узлов с изготовлением обвязки на месте монтажа, без обводной линии",
    "Установка узлов тепловых элеваторных",
    "Установка узлов конденсатоотводчиков",
    "Установка фланцевых соединений на стальных трубопроводах",
    "Установка вентилей, задвижек, затворов, клапанов обратных, кранов проходных на трубопроводах из стальных труб",
    "Установка вентилей, задвижек, затворов, клапанов обратных, кранов проходных на трубопроводах из чугунных напорных фланцевых труб",
    "Установка клапанов предохранительных",
    "Установка клапанов приемных",
    "Установка клапанов редукционных пружинных",
    "Установка кранов",
    "Установка воронок",
    "Установка муфт противопожарных на трубопроводы пластиковые",
    "Установка контрольно-измерительных приборов и кранов воздушных. Манометры. Термометры.",
    "Изготовление стальных гильз",
    "Установка шкафов",
    "Установка распределительного коллектора для систем отопления и водоснабжения",
    "Врезка в действующие внутренние сети трубопроводов отопления и водоснабжения",
    "Врезка в действующие внутренние сети трубопроводов канализации",
    "Гидравлическое испытание трубопроводов систем отопления, водопровода и горячего водоснабжения",
    "Заделка сальников при проходе труб через фундаменты или стены подвала",
    "Герметизация ввода коммуникаций через стену с использованием инъекционных двухкомпонентных полиуретановых составов пены и смолы",
    "Установка котлов отопительных чугунных секционных на твердом топливе водогрейных",
    "Установка котлов стальных жаротрубных пароводогрейных на твердом топливе",
    "Установка водоподогревателей скоростных односекционных",
    "Установка секций водоподогревателей скоростных",
    "Установка водоподогревателей емкостных",
    "Монтаж водонагревателей электрических накопительных (емкостных)",
    "Монтаж проточных водонагревателей электрических",
    "Установка пластинчатых теплообменников для систем отопления и горячего водоснабжения",
    "Установка конвекторов",
    "Установка регистров из стальных: водогазопроводных труб",
    "Установка регистров из стальных: сварных труб",
    "Установка терморегулирующих клапанов на отопительных приборах",
    "Установка радиаторов алюминиевых и биметаллических с креплением к стене",
    "Установка радиаторов чугунных",
    "Установка радиаторов стальных панельных однорядных с креплением к стене",
    "Установка радиаторов стальных панельных однорядных с креплением к полу",
    "Установка баков расширительных круглых и прямоугольных",
    "Установка баков унифицированных с переливным",
    "Установка баков конденсационных",
    "Установка поддонов металлических",
    "Установка насосов центробежных с электродвигателем",
    "Установка вставок виброизолирующих к насосам",
    "Установка ручных насосов",
    "Установка гребенок пароводораспределительных из стальных труб",
    "Установка грязевиков",
    "Установка воздухосборников",
    "Установка воздухоотводчиков",
    "Установка элеваторов",
    "Установка фильтров",
    "Установка указателей уровня кранового типа",
    "Установка манометров: с трехходовым краном",
    "Установка манометров: с трехходовым краном и трубкой-сифоном",
    "Установка термометров в оправе прямых и угловых",
    "Установка кранов воздушных",
    "Прокладка воздуховодов из листовой оцинкованной стали и алюминия класса Н (нормальные)",
    "Прокладка воздуховодов из листовой оцинкованной стали и алюминия класса П (плотные)",
    "Прокладка воздуховодов для АЭС и ТЭС из листовой оцинкованной стали",
    "Прокладка воздуховодов для АЭС и ТЭС из листовой стали",
    "Прокладка воздуховодов из коррозионностойкой стали",
    "Прокладка воздуховодов для систем аспирации и пневмотранспорта из тонколистовой стали, круглых",
    "Прокладка воздуховодов для АЭС и ТЭС из листовой углеродистой стали",
    "Прокладка воздуховодов из листовой оцинкованной стали и алюминия класса Н (нормальные)",
    "Прокладка воздуховодов из листовой оцинкованной стали и алюминия класса П (плотные)",
    "Прокладка воздуховодов для АЭС и ТЭС из листовой оцинкованной стали",
    "Прокладка воздуховодов для АЭС и ТЭС из листовой стали",
    "Прокладка воздуховодов из коррозионностойкой стали",
    "Прокладка воздуховодов для систем аспирации и пневмотранспорта из тонколистовой стали, круглых",
    "Прокладка воздуховодов для АЭС и ТЭС из листовой углеродистой стали",
    "Установка воздухораспределителей, предназначенных для подачи воздуха: в рабочую зону",
    "Установка решеток жалюзийных",
    "Установка пластиковых вентиляционных решеток площадью в свету до 0,05 м2",
    "Установка решеток жалюзийных стальных или алюминиевых: неподвижных односекционных",
    "Установка решеток жалюзийных стальных или алюминиевых: штампованных нерегулируемых (РШ)",
    "Установка решеток жалюзийных стальных или алюминиевых: регулирующих (РР)",
    "Установка решеток жалюзийных стальных или алюминиевых: щелевых регулирующих (Р)",
    "Установка клапанов обратных",
    "Установка клапанов: лепестковых к осевым вентиляторам",
    "Установка клапанов: перекидных утепленных в шахте",
    "Установка клапанов: огнезадерживающих с ручной регулировкой",
    "Установка клапанов: перекидных",
    "Установка заслонок воздушных и клапанов воздушных КВР с ручным приводом",
    "Установка заслонок воздушных, клапанов воздушных КВР и противопожарных клапанов с электрическим или пневматическим приводом",
    "Установка клапанов воздушных утепленных КВУ с электрическим или пневматическим приводом",
    "Установка отсосов от оборудования",
    "Установка отсосов бортовых",
    "Установка зонтов над шахтами из листовой стали круглого сечения",
    "Установка зонтов над шахтами из листовой стали прямоугольного сечения",
    "Установка зонтов над оборудованием",
    "Установка дефлекторов",
    "Установка узлов прохода вытяжных вентиляционных шахт",
    "Установка шумоглушителей вентиляционных трубчатых круглого сечения",
    "Установка шумоглушителей вентиляционных трубчатых",
    "Установка пластин глушителей шума вентиляционных установок пластинчатых",
    "Установка дверей герметических",
    "Установка люков герметических",
    "Установка вставок гибких к радиальным вентиляторам",
    "Установка кронштейнов под вентиляционное оборудование",
    "Установка виброизолятора",
    "Установка вентиляторов радиальных",
    "Установка вентиляторов радиальных с клиноременным приводом",
    "Установка вентиляторов осевых",
    "Установка вентиляторов крышных",
    "Установка агрегатов вентиляционных пылеулавливающих",
    "Установка канальных вентиляторов",
    "Установка агрегатов воздушно-отопительных",
    "Установка калориферов",
    "Установка фильтров ячейковых",
    "Установка фильтров аэрозольных",
    "Установка скрубберов",
    "Установка циклонов",
    "Установка кондиционеров доводчиков эжекционных",
    "Установка камер приточных типовых: без секции орошения",
    "Установка камер приточных типовых: с секцией орошения",
    "Установка камер орошения",
    "Установка фильтров воздушных сетчатых (масляных)",
    "Установка фильтров воздушных",
    "Установка воздухонагревателей однорядных для обводного канала",
    "Установка воздухонагревателей двухрядных для обводного канала",
    "Установка камер обслуживания",
    "Установка камер воздушных",
    "Установка клапанов воздушных",
    "Установка клапанов воздушных: для обвода воздухонагревателей",
    "Установка блоков тепломассообмена",
    "Присоединение трубопроводов к оросительной системе блока тепломассообмена",
    "Установка агрегатов вентиляторных",
    "Установка блоков присоединительных",
    "Установка блоков приемных",
    "Установка кондиционеров оконных",
    "Установка сплит-систем с внутренним блоком настенного типа",
    "Установка сплит-систем с внутренним блоком напольного типа",
    "Установка сплит-систем с внутренним блоком кассетного типа",
    "Установка сплит-систем с внутренним блоком канального типа",
    "Установка внешнего блока мульти сплит-системы",
    "Установка внутреннего блока настенного типа",
    "Установка внутреннего блока напольного типа",
    "Установка внутреннего блока кассетного типа",
    "Установка внутреннего блока канального типа",
    "Установка каркасно-панельных кондиционеров",
    "Прокладка трубных проводок из цветных металлов",
    "Изоляция трубопроводов конструкциями теплоизоляционными комплектными на основе цилиндров минераловатных на синтетическом связующем",
    "Изоляция трубопроводов цилиндрами, полуцилиндрами и сегментами из пенопласта",
    "Изоляция трубопроводов цилиндрами и полуцилиндрами из минеральной ваты на синтетическом связующем",
    "Изоляция трубопроводов изделиями (сегментами) минераловатными на битумном связующем",
    "Изоляция трубопроводов холстами стекловолокнистыми, полотном холстопрошивным стекловолокнистым марки ПХС-Т, полотном иглопробивным стеклянным марки ИПС-Т",
    "Изоляция трубопроводов шнурами",
    "Изоляция трубопроводов матами и холстами из супертонкого волокна (стеклянного и базальтового), матами звукопоглощающими",
    "Изоляция трубопроводов матами минераловатными, плитами минераловатными, плитами из стеклянного штапельного волокна",
    "Изоляция трубопроводов матами минераловатными прошивными безобкладочными и в обкладках, изделиями минераловатными с гофрированной структурой, матами из стеклянного штапельного волокна",
    "Изоляция арматуры и фланцевых соединений съемными полуфутлярами из матов минераловатных прошивных и листов алюминиевых сплавов",
    "Изоляция арматуры и фланцевых соединений съемными полуфутлярами из матов минераловатных прошивных и листов оцинкованной стали",
    "Изоляция арматуры и фланцевых соединений съемными полуфутлярами из матрацев минераловатных и листов алюминиевых сплавов, оцинкованной стали",
    "Изоляция трубопроводов изготавливаемыми в процессе изоляции конструкциями полносборными с покрытием из листов алюминиевых сплавов",
    "Изоляция трубопроводов изготавливаемыми в процессе изоляции конструкциями полносборными с покрытием сталью оцинкованной",
    "Изоляция изделиями из вспененного каучука, вспененного полиэтилена трубопроводов",
    "Изоляция арматуры и фланцевых соединений пластинами (плитами) из вспененного каучука, вспененного полиэтилена",
    "Изоляция трубопроводов пенополиуретаном методом заливки под защитное металлическое покрытие из листов алюминиевых сплавов или стали оцинкованной листовой",
    "Изоляция стальных трубопроводов жидким теплоизоляционным покрытием",
    "Изоляция арматуры и фланцевых соединений стальных трубопроводов жидким теплоизоляционным покрытием",
    "Огнезащитное покрытие воздуховодов составом на основе минеральных волокон методом торкретирования",
    "Огнезащитное покрытие металлоконструкций комплексной огнезащитой на основе плит теплоизоляционных",
    "Огнезащитное покрытие воздуховодов комплексной огнезащитой на основе плит теплоизоляционных",
    "Огнезащитное покрытие воздуховодов пастовым составом",
    "Заделка проходок стальных труб",
    "Огнезащитная заделка деформационных швов",
    "Заделка проходок воздуховодов",
    "Заделка проходок инженерных коммуникаций"
];

export default workCategories; 